import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import SelectedListItem from './SelectedListItem';
import ClientProvider from './client';
export default createDemo(import.meta.url, SelectedListItem, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/lists/demos/selected-item/SelectedListItem.tsx",
    "fileName": "SelectedListItem.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport List from '@mui/material/List';\nimport ListItemButton from '@mui/material/ListItemButton';\nimport ListItemIcon from '@mui/material/ListItemIcon';\nimport ListItemText from '@mui/material/ListItemText';\nimport Divider from '@mui/material/Divider';\nimport InboxIcon from '@mui/icons-material/Inbox';\nimport DraftsIcon from '@mui/icons-material/Drafts';\n\nexport default function SelectedListItem() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [selectedIndex, setSelectedIndex] = React.useState(1);\n\n  const handleListItemClick = (\n    event: React.MouseEvent<HTMLDivElement, MouseEvent>,\n    index: number,\n  ) => {\n    setSelectedIndex(index);\n  };\n\n  return (\n    <Box sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>\n      <List component=\"nav\" aria-label=\"main mailbox folders\">\n        <ListItemButton\n          selected={selectedIndex === 0}\n          onClick={(event) => handleListItemClick(event, 0)}\n        >\n          <ListItemIcon>\n            <InboxIcon />\n          </ListItemIcon>\n          <ListItemText primary=\"Inbox\" />\n        </ListItemButton>\n        <ListItemButton\n          selected={selectedIndex === 1}\n          onClick={(event) => handleListItemClick(event, 1)}\n        >\n          <ListItemIcon>\n            <DraftsIcon />\n          </ListItemIcon>\n          <ListItemText primary=\"Drafts\" />\n        </ListItemButton>\n      </List>\n      <Divider />\n      <List component=\"nav\" aria-label=\"secondary mailbox folder\">\n        <ListItemButton\n          selected={selectedIndex === 2}\n          onClick={(event) => handleListItemClick(event, 2)}\n        >\n          <ListItemText primary=\"Trash\" />\n        </ListItemButton>\n        <ListItemButton\n          selected={selectedIndex === 3}\n          onClick={(event) => handleListItemClick(event, 3)}\n        >\n          <ListItemText primary=\"Spam\" />\n        </ListItemButton>\n      </List>\n    </Box>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 60,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport List from '@mui/material/List';\nimport ListItemButton from '@mui/material/ListItemButton';\nimport ListItemIcon from '@mui/material/ListItemIcon';\nimport ListItemText from '@mui/material/ListItemText';\nimport Divider from '@mui/material/Divider';\nimport InboxIcon from '@mui/icons-material/Inbox';\nimport DraftsIcon from '@mui/icons-material/Drafts';\n\nexport default function SelectedListItem() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [selectedIndex, setSelectedIndex] = React.useState(1);\n\n  const handleListItemClick = (\n    event: React.MouseEvent<HTMLDivElement, MouseEvent>,\n    index: number,\n  ) => {\n    setSelectedIndex(index);\n  };\n\n  return (\n    <Box sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>\n      <List component=\"nav\" aria-label=\"main mailbox folders\">\n        <ListItemButton\n          selected={selectedIndex === 0}\n          onClick={(event) => handleListItemClick(event, 0)}\n        >\n          <ListItemIcon>\n            <InboxIcon />\n          </ListItemIcon>\n          <ListItemText primary=\"Inbox\" />\n        </ListItemButton>\n        <ListItemButton\n          selected={selectedIndex === 1}\n          onClick={(event) => handleListItemClick(event, 1)}\n        >\n          <ListItemIcon>\n            <DraftsIcon />\n          </ListItemIcon>\n          <ListItemText primary=\"Drafts\" />\n        </ListItemButton>\n      </List>\n      <Divider />\n      <List component=\"nav\" aria-label=\"secondary mailbox folder\">\n        <ListItemButton\n          selected={selectedIndex === 2}\n          onClick={(event) => handleListItemClick(event, 2)}\n        >\n          <ListItemText primary=\"Trash\" />\n        </ListItemButton>\n        <ListItemButton\n          selected={selectedIndex === 3}\n          onClick={(event) => handleListItemClick(event, 3)}\n        >\n          <ListItemText primary=\"Spam\" />\n        </ListItemButton>\n      </List>\n    </Box>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 60,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Box",
      "@mui/material/List",
      "@mui/material/ListItemButton",
      "@mui/material/ListItemIcon",
      "@mui/material/ListItemText",
      "@mui/material/Divider",
      "@mui/icons-material/Inbox",
      "@mui/icons-material/Drafts"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
